// Presence device identity (office comms L1-3, 2026-09-08 — finding F5).
//
// A module-scope UUID minted ONCE per tab LOAD. Deliberately:
//   - NOT sessionStorage — Chrome copies sessionStorage on tab duplication,
//     so two live tabs would share one identity (merged/blinking chips);
//   - NOT the SSE connectionId — it rotates on every reconnect, which would
//     produce duplicate chips + ~90s ghost viewers server-side.
// A page refresh minting a fresh id is fine: the old id stops heartbeating
// and sweeps out as stale on the server.
const TAB_DEVICE_ID =
  typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
    ? crypto.randomUUID()
    : `tab-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;

export default TAB_DEVICE_ID;
